// extracted by mini-css-extract-plugin
export default {"aboutText":"styles_aboutText__YGBPQ"};